import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungs-typ-felder-sortieren';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypFelderSortierenEffects {

    VeranstaltungsTypFelderSortieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGS_TYP_FELDER_SORTIEREN),
        mergeMap((x: ac.PostVeranstaltungsTypFelderSortierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungsTypFelderSortieren(x.veranstaltungsTypIdArrayRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungsTypFelderSortierenErfolgreichAction(result, x.veranstaltungsTypIdArrayRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungsTypFelderSortierenFehlerAction(error, x.veranstaltungsTypIdArrayRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenCommandService);
        }
        return this.service;
    }
}
